import React from 'react';
import { Formik } from 'formik';
import { Icon, Card, Steps } from 'antd';
import moment from 'moment';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import Wrapper from './Wrapper';
import { createEvent } from '../../store/actions/event';
import useSteps from '../../effects/useSteps';
import config from './config';
import styles from '../../styles';

const { Step } = Steps;

const style = {
  steps: { marginBottom: 30 },
};

const CreateEvent = ({ createEvent, history }) => {
  const { step, setStep, isLast } = useSteps({ max: 2 });
  const settings = config[step];

  const initialValues = {
    dateTime: moment(),
  };

  const onSubmit = data =>
    createEvent(data).then(() => history.push('/events'));

  const onClose = () => history.goBack();

  return (
    <Card
      title="Create Event"
      style={styles.formContainer}
      extra={<Icon type="close" onClick={onClose} />}
    >
      <Steps current={step} style={style.steps}>
        <Step title="Choose direction" />
        <Step title="Choose event type" />
        <Step title="Input event details" />
      </Steps>

      <Formik
        validationSchema={settings.validate}
        onSubmit={onSubmit}
        initialValues={initialValues}
      >
        {({ handleSubmit, validateForm, isValid, values, setFieldValue }) => (
          <Wrapper
            handleSubmit={handleSubmit}
            validateForm={validateForm}
            values={values}
            setValue={setFieldValue}
            settings={settings}
            isValid={isValid}
            isLast={isLast}
            setStep={setStep}
          />
        )}
      </Formik>
    </Card>
  );
};

CreateEvent.propTypes = {
  createEvent: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
  }).isRequired,
};

export default withRouter(connect(null, { createEvent })(CreateEvent));
